import React from 'react'
import styled from '@emotion/styled'
import { font } from '@mobi/component-library/Theme/Common'
import emptyStateSvgAsset from './assets/feedEmptyState.png'

export const EmptyFeedMessage: React.FC<{ title: string; description: string }> = ({
  title,
  description,
}) => (
  <WrapperStyled>
    <img src={emptyStateSvgAsset} width='334' height='275' alt='Follow Me Feed Empty' />

    <div>{title}</div>

    <div>{description}</div>
  </WrapperStyled>
)

// =======
// Styles
// =======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: font.family.primary,
  fontSize: font.size.lg.fontSize,
  lineHeight: font.size.lg.lineHeight,
  paddingTop: '8rem',
  textAlign: 'center',

  '> div:first-of-type': {
    fontWeight: font.weight.semibold,
    paddingTop: '2rem',
  },

  '> div:last-of-type': {
    fontWeight: font.weight.regular,
    whiteSpace: 'pre-wrap',
  },
})
